angular
  .module('data-ng-path-item')
  .constant('GeoJsonBuilderDTD', {
    type: 'string',
    id: 'key',
    comments: 'string',
    address: 'string',
    properties: {
      type: 'object' // TODO: make geojson properties factory
    },
    geometry: {
      type: 'object' // TODO: make geojson geometry factory
    }
  })
  .factory('GeoJsonBuilder', function GeoJsonBuilder(Interface, GeoJsonBuilderDTD) {
    function GeoJsonDTO(data) {
      Interface.implement(GeoJsonBuilderDTD, data, this);
      applyType.call(this, data);
      applyProperties.call(this, data);
      applyGeometry.call(this, data);
    }

    var applyType = function applyType(data) {
      this.type = data.type || 'Feature';
    };

    var applyProperties = function applyProperties(data) {
      var template = '<h4>{{properties.name}}</h4><p>{{address}}</p>';

      this.properties.name = data.name;
      if (!data.notemplate) {
        this.properties.popupContent = _.template(template, this);
      }
    };

    var applyGeometry = function applyGeometry(data) {
      this.geometry.type = data.type || 'Point';
      this.geometry.coordinates =
        _.isNull(data.longitude) || _.isNull(data.latitude) ? {} : [data.longitude, data.latitude];
    };

    return GeoJsonDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/builders/geojson_builder.js